import React, { useContext } from 'react';
import './ContactBar.module.scss';
import { TextInput } from 'components/UI/Form/Input';
import {
    faEnvelope,
    faPaperPlane,
    faPhone,
} from '@fortawesome/pro-solid-svg-icons';
import Button from 'components/UI/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QuizContext } from 'screens/Quiz/Quiz';
import { useDispatch } from 'react-redux';
import sendQuiz from 'actions/mail/quiz';

export default function ContactBar() {
    const dispatch = useDispatch();
    const { email, setEmail, answers, phone } = useContext(QuizContext);
    return (
        <div styleName="contact-bar ">
            <div styleName="image-wrapper ">
                <img src="/images/laura.png" alt="Laura Romme" />
            </div>
            <div styleName="column-wrapper">
                <h4>Laura Romme</h4>
                <p>Begeleider overstap - {answers?.question1}</p>
            </div>
            <div styleName="column-wrapper">
                <a href="tel:0413283090" styleName="icon-row">
                    <FontAwesomeIcon icon={faPhone} />
                    <p>0413 283090</p>
                </a>
                <a
                    href="mailto:info@grijpjekansinhetonderwijs.nl"
                    styleName="icon-row"
                >
                    <FontAwesomeIcon icon={faEnvelope} />
                    <p>info@grijpjekansinhetonderwijs.nl</p>
                </a>
            </div>
            <div styleName="input-column">
                <p>
                    Wil je meer informatie? Vul hier dan je e-mailadres in als
                    je dat nog niet gedaan hebt.
                </p>
                <div styleName="input-wrapper">
                    <TextInput
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        noMargin
                        placeholder="E-mailadres"
                        type="email"
                    />
                    <div styleName="button-wrapper">
                        <Button
                            onClick={() => {
                                dispatch(
                                    sendQuiz({
                                        answers,
                                        phone,
                                        email,
                                    })
                                );
                            }}
                            icon={faPaperPlane}
                        >
                            Verzenden
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
